import _              from 'lodash'
import React          from 'react'
import { withRouter } from 'react-router'
import { Link       } from 'react-router-dom'
import { Alert      } from 'react-bootstrap'
import PropTypes      from 'prop-types'

import { isValidEmail              } from 'alto-utils/lib/utils'
import Validation                    from 'alto-react-components/lib/validation'
import { Panel, HorizontalForm     } from 'alto-react-components/lib/components'
import { withAuthMessage           } from 'alto-react-base-auth/lib/utils'
import { tradeTermsSetting, sensitiveDataSetting, emailAsUsernameSetting,
         passwordValidationSetting } from 'alto-react-base-auth/lib/settings'

import './registration.sass'

class Registration extends React.Component
  @contextTypes =
    auth:     PropTypes.object
    settings: PropTypes.object

  constructor: (props, context) ->
    super(props, context)

    tradeTerms         = tradeTermsSetting(context.settings)
    sensitiveData      = sensitiveDataSetting(context.settings)
    emailAsUsername    = emailAsUsernameSetting(context.settings)
    passwordValidation = passwordValidationSetting(context.settings)

    @state =
      email:                ''
      username:             ''
      password:             ''
      passwordConfirmation: ''

      tradeTerms:          tradeTerms
      tradeTermsAgreed:    tradeTerms.initially
      sensitiveData:       sensitiveData
      sensitiveDataAgreed: sensitiveData.initially
      emailAsUsername:     emailAsUsername
      useEmailAsUsername:  emailAsUsername.initially
      passwordValidation:  new Validation(passwordValidation)

      errors: {}

  render: ->
    <div>
      <Panel className="auth-panel" id="registration-panel" header="Registrace" bsStyle="info">
        {@content()}
      </Panel>

      {@contactInfo()}
    </div>

  content: ->
    <div>
      {@info()}
      {@alert()}
      {@form()}
    </div>

  info: ->

  alert: ->
    <Alert bsStyle="danger">{@state.errors.detail}</Alert> if @state.errors?.detail

  contactInfo: ->
    # FIXME: contact form is defined by client-auth so base-auth shouldn't know about it
    # - either move this alert to client auth or move contact form to base-auth
    <Alert className='contact-info'>
      Nedaří se Vám zaregistrovat? <Link to='/support/contact_form'>Kontaktujte nás</Link>.
    </Alert>

  form: ->
    <HorizontalForm className='registration-form login-credentials'>
      {@useEmailAsUsernameCheckbox()}
      {@emailInput()}
      {@usernameInput()}
      {@passwordInput()}
      {@passwordConfirmationInput()}
      {@additionalInputs()}
      {@tradeTermsCheckbox()}
      {@sensitiveDataCheckbox()}
      {@sensitiveDataFullText()}
      {@submitButton()}
    </HorizontalForm>

  useEmailAsUsernameCheckbox: ->
    { checkbox, always } = @state.emailAsUsername

    if checkbox
      <HorizontalForm.Checkbox id='use-email-as-username'
       label='Použít email jako přihlašovací jméno'
       managed={not always}
       value={@state.useEmailAsUsername}
       onChange={(value) => @setState(useEmailAsUsername: value)} />

  emailInput: ->
    <HorizontalForm.Control id='email' type='email' label='Email'
     valid={@isEmailValid()}
     placeholder={'Zadejte email'}
     value={@state.email}
     onChange={(value) => @setState(email: value)}
     onKeyPress={(e)   => @submit() if e.key == 'Enter'} />

  usernameInput: ->
    if @state.emailAsUsername.always
      <HorizontalForm.Static id='username' label='Přihlašovací jméno'
       value='Stejné jako registrovaný email' />
    else
      errors = @errorsFor('username')

      <HorizontalForm.Control id='username' type='text' label='Přihlašovací jméno'
       disabled={@state.useEmailAsUsername}
       valid={@isUsernameValid() and !errors?} help={errors}
       placeholder={'Zadejte přihlašovací jméno' unless @state.useEmailAsUsername}
       value={@state.username}
       onChange={(value) => @setState(username: value)}
       onKeyPress={(e)   => @submit() if e.key == 'Enter'} />

  # TODO: validate validation spec - dismiss any invalid values

  passwordInput: ->
    errors = @validatePassword()
    help   = errors.length and errors.map (error, index) -> <p key={index}>{error}</p>

    <HorizontalForm.Control id='password' type="password" label='Heslo'
     valid={!errors.length} help={help}
     placeholder='Zadejte heslo'
     value={@state.password}
     onChange={(value) => @setState(password: value)}
     onKeyPress={(e)   => @submit() if e.key == 'Enter'} />

  passwordConfirmationInput: ->
    <HorizontalForm.Control id='password-confirmation' type="password" label='Ověření hesla'
     valid={@isPasswordConfirmed()}
     help={'Neshoduje se' unless @isPasswordConfirmed()}
     placeholder='Zadejte heslo ještě jednou'
     value={@state.passwordConfirmation}
     onChange={(value) => @setState(passwordConfirmation: value)}
     onKeyPress={(e)   => @submit() if e.key == 'Enter'} />

  additionalInputs: ->

  tradeTermsCheckbox: ->
    { show, linkUrl, linkText, checkboxText } = @state.tradeTerms

    if show
      if linkUrl
        content = <span>Souhlasím s <a href={linkUrl} target="_blank">{linkText}</a></span>
      else
        content = checkboxText

      <HorizontalForm.Checkbox id='terms' value={@state.tradeTermsAgreed}
                               onChange={(value) => @setState(tradeTermsAgreed: value)}>
        {content}
      </HorizontalForm.Checkbox>

  sensitiveDataCheckbox: ->
    { show, linkUrl, linkText, checkboxText } = @state.sensitiveData

    if show
      if linkUrl
        content = <span>Souhlasím se <a href={linkUrl} target="_blank">{linkText}</a></span>
      else
        content = checkboxText

      <HorizontalForm.Checkbox id='sensitive-data' value={@state.sensitiveDataAgreed}
                               onChange={(value) => @setState(sensitiveDataAgreed: value)}>
        {content}
      </HorizontalForm.Checkbox>

  sensitiveDataFullText: ->
    { show, fullText } = @state.sensitiveData

    <p id="gdpr-full-text" dangerouslySetInnerHTML={{ __html: fullText }} /> if show and fullText

  submitButton: ->
    <HorizontalForm.Button id='submit-credentials' caption='Registrovat' bsStyle="primary"
     disabled={!@isValid()} onClick={@submit.bind(@)} />

  submit: ->
    if @isValid()
      credentials = _.pick(@state, ['useEmailAsUsername', 'email', 'username', 'password'])

      @register(credentials)
        .then (response) =>
          @props.history.push(withAuthMessage('/', 'activation_email_sent', 'warning'))
          null # otherwise runaway promise
        .catch (error) =>
          @setState(errors: _.mapKeys(error.data, (val, key) -> _.camelCase(key)))

  register: (credentials) ->
    @context.auth.register(credentials)

  isValid: ->
    @isEmailValid() and @isUsernameValid() and @isPasswordValid() and @isPasswordConfirmed() and
      @tradeTermsAgreed() and @sensitiveDataAgreed()

  isEmailValid: ->
    isValidEmail(@state.email)

  isUsernameValid: ->
    @state.useEmailAsUsername or @state.username.length

  isPasswordValid: ->
    errors = @validatePassword()
    not errors.length

  isPasswordConfirmed: ->
    @state.password == @state.passwordConfirmation

  tradeTermsAgreed: ->
    @state.tradeTermsAgreed    or not @state.tradeTerms.show    or not @state.tradeTerms.required

  sensitiveDataAgreed: ->
    @state.sensitiveDataAgreed or not @state.sensitiveData.show or not @state.sensitiveData.required

  validatePassword: ->
    backendErrors  = @state.errors['password'] or []
    frontendErrors = @state.passwordValidation.validate(@state.password).map (message) =>
      'Heslo ' + message + '.'

    _.concat(backendErrors, frontendErrors)

  errorsFor: (fieldName) ->
    @state.errors[fieldName]?.join(' ')

export default withRouter(Registration)
